import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { deliverableImportClient } from '../../../../lib/connect/clients';
const DeliverableImportClientContext = /*#__PURE__*/ createContext(deliverableImportClient);
/**
 * Injects a DeliverableImportClient for a subtree — the dev fixture route and
 * tests use this to swap in an in-memory fake, since the real ryugu handler
 * doesn't exist yet.
 */ export function DeliverableImportClientProvider({ client, children }) {
    return /*#__PURE__*/ _jsx(DeliverableImportClientContext.Provider, {
        value: client,
        children: children
    });
}
export function useDeliverableImportClient() {
    return useContext(DeliverableImportClientContext);
}
